import { render, staticRenderFns } from "./ClientConfirmation.vue?vue&type=template&id=1045ccf2"
import script from "./ClientConfirmation.vue?vue&type=script&lang=js"
export * from "./ClientConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports